import { render, staticRenderFns } from "./SmartToggleBox.vue?vue&type=template&id=68be8098"
import script from "./SmartToggleBox.vue?vue&type=script&lang=js"
export * from "./SmartToggleBox.vue?vue&type=script&lang=js"
import style0 from "./SmartToggleBox.vue?vue&type=style&index=0&id=68be8098&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports